// extracted by mini-css-extract-plugin
module.exports = {"favoriteButton":"FavoriteButton_favoriteButton__QzqVR","loadingIcon":"FavoriteButton_loadingIcon__l4NE0"};